import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import Login from './components/Login';
import Register from './components/Register';
import Dashboard from './components/Dashboard';
import AdminDashboard from './components/AdminDashboard';
import SystemAdmin from './components/SystemAdmin';
import ForgotPassword from './components/ForgotPassword';
import ProtectedRoute from './components/ProtectedRoute';
import NotFound from './components/NotFound';
import UserDetail from './components/UserDetail';
import Account from './components/Account';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          {/* Admin Dashboard - Main admin interface */}
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute requiredPermission="can_view_admin_dash">
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          {/* System Admin - Technical/system administration */}
          <Route
            path="/system-admin"
            element={
              <ProtectedRoute requiredPermission="can_view_admin_dash">
                <SystemAdmin />
              </ProtectedRoute>
            }
          />
          {/* Redirect /admin to /admin/dashboard */}
          <Route
            path="/admin"
            element={<Navigate to="/admin/dashboard" replace />}
          />
          {/* User detail - permission checked inside the component so a
              missing permission renders 404 rather than redirecting */}
          <Route
            path="/admin/user/:id"
            element={
              <ProtectedRoute>
                <UserDetail />
              </ProtectedRoute>
            }
          />
          {/* Own account - no permission beyond being signed in */}
          <Route
            path="/account"
            element={
              <ProtectedRoute>
                <Account />
              </ProtectedRoute>
            }
          />
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;